
import VueI18n from 'vue-i18n';
import { Picker } from 'emoji-mart-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueTippy, { TippyComponent } from "vue-tippy";
import { Datetime } from 'vue-datetime';
import draggable from 'vuedraggable';

// CSS
import 'vue-datetime/dist/vue-datetime.css';
import "tippy.js/themes/light-border.css";

// Font Awesome
import {
    faCalendarDay,
    faClock,
    faGrin,
    faGripLines,
    faCheck,
    faPen,
    faTrashAlt,
    faPlus,
    faToggleOn,
    faToggleOff,
    faImage,
    faThumbsUp,
    faThumbsDown,
    faDesktop,
    faSort,
    faSortUp,
    faSortDown,
    faTimesCircle,
    faLink,
    faBold,
    faItalic,
    faUnderline,
    faCalendarAlt,
    faCog,
    faEye,
    faExclamationTriangle,
    faBan,
    faFileAudio
} from '@fortawesome/free-solid-svg-icons';
import MusicExport from "./Statistics/MusicExport";
import PushWidget from "./PushWidget/PushWidget";

import Vip from "./Vip/Vip";
import Editor from "./FrontpageEditor/Editor";
import EpisodeListing from "./EpisodeListing/EpisodeListing";
import EpisodeEditor from "./EpisodeEditor/EpisodeEditor";
import ImageUpload from "./ImageUpload/ImageUpload";
import DeleteButton from "./DeleteButton/DeleteButton";
import ConfirmButton from "./ConfirmButton/ConfirmButton";
import VueSelect from "./VueSelect/VueSelect";
import AutopublishWidget from "./AutopublishWidget/AutopublishWidget";
import AutopublishFormWidget from "./AutopublishWidget/AutopublishFormWidget";
import CollectionList from "./ResourceList/CollectionList";
import IntroSoundtrack from "./IntroSoundtrack/IntroSoundtrack";
import Vue from "vue";
import PublishedStories from "./PublishedStories/PublishedStories";
// import PromoCodeChart from "./Charts/PromoCodeChart";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('./ResetPassword/ResetPassword')

/**
 * Add Font Awesome icons to library
 */
library.add(
    faGrin,
    faGripLines,
    faCheck,
    faPen,
    faTrashAlt,
    faPlus,
    faToggleOff,
    faToggleOn,
    faImage,
    faThumbsUp,
    faThumbsDown,
    faClock,
    faCalendarDay,
    faDesktop,
    faSort,
    faSortDown,
    faSortUp,
    faTimesCircle,
    faLink,
    faBold,
    faItalic,
    faUnderline,
    faCalendarAlt,
    faCog,
    faEye,
    faExclamationTriangle,
    faBan,
    faFileAudio
);

/**
 * Add some plugins to Vue
 */
Vue.use(VueI18n);
Vue.use(VueTippy);
Vue.use(draggable);
//Vue.use(Datetime)

// Dependencies
Vue.component("tippy", TippyComponent);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('picker', Picker);
Vue.component('datetime', Datetime);
Vue.component('draggable',draggable);
// Components
Vue.component('music-export', MusicExport);
Vue.component('push-widget', PushWidget);
Vue.component('vip-access', Vip);
Vue.component('frontpage-editor', Editor);
Vue.component('episode-listing', EpisodeListing);
Vue.component('episode-editor', EpisodeEditor);
Vue.component('image-upload', ImageUpload);
Vue.component('delete-button', DeleteButton);
Vue.component('confirm-button', ConfirmButton);
Vue.component('vue-select', VueSelect);
Vue.component('autopublish-widget', AutopublishWidget);
Vue.component('autopublish-formwidget', AutopublishFormWidget);
Vue.component('collection-list', CollectionList);
Vue.component("intro-soundtrack", IntroSoundtrack);
Vue.component('published-stories', PublishedStories);
// Vue.component('promo-code-chart', PromoCodeChart);
// Vue.component('promocodechart', require('./views/components/chart/promocodechart.vue').default);

const app = new Vue({
    el: '#app'
});
